import React, { useEffect, useState } from 'react';
import robotImage from '../assets/images/robot-header.png';

const UnderConstructionModal = ({ isOpen, onClose }) => {
  const [walkIn, setWalkIn] = useState(false);
  const [reachedButton, setReachedButton] = useState(false);
  const [putUpSign, setPutUpSign] = useState(false);
  const [hammerHit, setHammerHit] = useState(0);
  const [leftLegForward, setLeftLegForward] = useState(true);

  useEffect(() => {
    if (isOpen) {
      // Start walking in
      setTimeout(() => setWalkIn(true), 100);
      
      // Alternate legs while walking
      const legInterval = setInterval(() => {
        setLeftLegForward(prev => !prev);
      }, 300);
      
      // Reached the button position
      setTimeout(() => {
        clearInterval(legInterval);
        setReachedButton(true);
      }, 2500);
      
      // Put up the sign
      setTimeout(() => setPutUpSign(true), 3000);
      
      // Hammer hits
      setTimeout(() => setHammerHit(1), 3500);
      setTimeout(() => setHammerHit(2), 3800);
      setTimeout(() => setHammerHit(3), 4100);
      
      return () => clearInterval(legInterval);
    } else {
      // Reset animation
      setWalkIn(false);
      setReachedButton(false);
      setPutUpSign(false);
      setHammerHit(0);
      setLeftLegForward(true);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="absolute left-0 right-0 top-0 bottom-0 z-50 pointer-events-none overflow-visible">
      {/* Robot flies in from right and stops at button position */}
      <div 
        className={`absolute transition-all ease-out pointer-events-auto`}
        style={{
          top: '50%',
          transform: 'translateY(-50%)',
          right: walkIn && !reachedButton ? '110%' : '-200px',
          transitionDuration: '3000ms'
        }}
      >
        <div className="relative">
          {/* Mini Robot with rocket flames */}
          <div className="relative w-24">
            <img 
              src={robotImage} 
              alt="Construction Robot" 
              className="w-full h-auto relative z-20"
            />
            
            {/* Rocket flames from boots while flying */}
            {!reachedButton && (
              <>
                <div className="absolute bottom-[15%] left-[38%] z-10">
                  <div className="flame flame-left-1"></div>
                  <div className="flame flame-left-2"></div>
                </div>
                <div className="absolute bottom-[15%] left-[58%] z-10">
                  <div className="flame flame-right-1"></div>
                  <div className="flame flame-right-2"></div>
                </div>
              </>
            )}
            
            {/* Construction hard hat on top */}
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 z-30">
              <div className="w-12 h-6 bg-yellow-400 rounded-t-full border-2 border-yellow-500 shadow-md"></div>
              <div className="w-14 h-1.5 bg-yellow-500 rounded-full -mt-1"></div>
            </div>
            
            {/* Hammer in hand */}
            <div className={`absolute top-[40%] -left-4 transition-transform duration-300 z-25 ${
              hammerHit > 0 ? '-rotate-45' : 'rotate-0'
            }`}>
              <div className="w-6 h-1.5 bg-gray-400 rounded"></div>
              <div className="ml-5 w-3 h-4 bg-gray-600 rounded-sm relative">
                <div className="absolute -top-1 left-0 w-3 h-1.5 bg-gray-700 rounded-t"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Sign being hung at an angle on the right side of robot */}
        {putUpSign && (
          <div 
            className="absolute z-30 transition-all duration-500" 
            style={{ 
              top: '-10px',
              left: '100px',
              transform: 'rotate(-8deg)',
              opacity: putUpSign ? 1 : 0
            }}
          >
            {/* Nails */}
            <div className="relative mb-1">
              <div className={`absolute -top-1 left-2 w-1.5 h-4 bg-gray-400 rounded-sm transition-all duration-300 ${hammerHit >= 1 ? 'translate-y-2' : ''}`}></div>
              <div className={`absolute -top-1 right-2 w-1.5 h-4 bg-gray-400 rounded-sm transition-all duration-300 ${hammerHit >= 3 ? 'translate-y-2' : ''}`}></div>
            </div>

            {/* The Sign */}
            <div className="bg-gradient-to-br from-yellow-100 to-yellow-50 border-4 border-yellow-400 rounded-lg p-3 shadow-xl relative" style={{ width: '160px' }}>
              {/* Caution tape borders */}
              <div className="absolute top-0 left-0 right-0 h-3 caution-stripes opacity-80 rounded-t-lg"></div>
              <div className="absolute bottom-0 left-0 right-0 h-3 caution-stripes opacity-80 rounded-b-lg"></div>
              
              <div className="relative z-10 text-center px-2 py-3">
                <div className="text-base font-bold text-gray-800 leading-tight">🚧 UNDER<br/>CONSTRUCTION 🚧</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UnderConstructionModal;

